// リーグの CSV 一括登録画面（leagues/csv_imports/new）の入力方法の切替。
// 選ばなかった方の入力欄は disabled にして送信しない（InputSource は両方の入力を同時に受け付けない）。
// 何も入力していないうちは「内容を確認する」を押せないようにし、押せない理由を迷わせない。
// 無料プラン（data-locked）では入力しても押せないままにする。
// 確定ボタンの二重送信防止は shared/form/actions（loading.js の form-submit スコープ）が担う

(function () {
  'use strict';

  $(document).on('turbolinks:load', function () {
    const $form = $('.js-csv-import-form');
    if (!$form.length) return;

    const $filePanel = $form.find('.js-csv-import-file-panel');
    const $textPanel = $form.find('.js-csv-import-text-panel');
    const $fileInput = $form.find('.js-csv-import-file');
    const $textInput = $form.find('.js-csv-import-text');
    const $submit = $form.find('.js-csv-import-submit');
    const isLocked = $form.data('locked') === true;

    function isFileMethod() {
      return $form.find('.js-csv-import-method:checked').val() !== 'text';
    }

    function updateSubmit() {
      const hasInput = isFileMethod() ? $fileInput.val() !== '' : $.trim($textInput.val()) !== '';
      $submit.prop('disabled', isLocked || !hasInput);
    }

    function applyInputMethod() {
      const isFile = isFileMethod();

      $filePanel.toggleClass('d-none', !isFile);
      $textPanel.toggleClass('d-none', isFile);
      $fileInput.prop('disabled', !isFile);
      $textInput.prop('disabled', isFile);
      updateSubmit();
    }

    $form.find('.js-csv-import-method').on('change', applyInputMethod);
    $fileInput.on('change', updateSubmit);
    $textInput.on('input', updateSubmit);
    applyInputMethod();

    // 読み込みに失敗したときは、エラーの一覧を画面内に出して読み上げさせる
    const $errors = $form.find('.js-csv-import-errors');
    if ($errors.length) {
      $errors[0].scrollIntoView({ block: 'center' });
      $errors[0].focus({ preventScroll: true });
    } else if (!isFileMethod() && $.trim($textInput.val()) !== '') {
      // 確認画面の「修正する」で戻ったときは、直す対象の貼り付け欄を開いた状態にする
      $textInput[0].scrollIntoView({ block: 'center' });
      $textInput[0].focus({ preventScroll: true });
    }
  });

  // リーグプレイヤーの名前を押すとコピーする（CSV を書きながら名前を写せるようにする）
  // document へのイベント委譲なので turbolinks:load の外で 1 回だけ登録する
  const COPIED_MS = 1500;

  // navigator.clipboard は https / localhost でしか使えないため、使えないときは選択してコピーする
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const isCopied = document.execCommand('copy');
    document.body.removeChild(textarea);
    return isCopied ? Promise.resolve() : Promise.reject(new Error('execCommand copy failed'));
  }

  // 形式の表（ヘッダー＋記入例）を Excel に貼り付けられる形でコピーする。
  // Excel はタブ区切りのテキストをセルに分けて貼り付ける。HTML も渡せるときは、
  // 「1-1」が日付（1月1日）に変換されないようセルを文字列（mso-number-format:@）として渡す
  function tableToTsv($table) {
    return $table.find('tr').map(function () {
      return $(this).children('th, td').map(function () {
        return $(this).text().trim().replace(/[\t\r\n]/g, ' ');
      }).get().join('\t');
    }).get().join('\n');
  }

  function tableToHtml($table) {
    const rows = $table.find('tr').map(function () {
      const cells = $(this).children('th, td').map(function () {
        const text = $('<div>').text($(this).text().trim()).html();
        return '<td style="mso-number-format:\'\\@\'">' + text + '</td>';
      }).get().join('');
      return '<tr>' + cells + '</tr>';
    }).get().join('');
    return '<table>' + rows + '</table>';
  }

  function copyTable($table) {
    const tsv = tableToTsv($table);
    if (navigator.clipboard && window.isSecureContext && window.ClipboardItem) {
      const item = new window.ClipboardItem({
        'text/plain': new Blob([tsv], { type: 'text/plain' }),
        'text/html': new Blob([tableToHtml($table)], { type: 'text/html' })
      });
      return navigator.clipboard.write([item]).catch(function () {
        return copyText(tsv);
      });
    }
    return copyText(tsv);
  }

  $(document).on('click', '.js-csv-import-sample-copy', function () {
    const $sample = $(this).closest('.js-csv-import-sample');
    const $status = $sample.find('.js-csv-import-sample-status');
    const i18n = $sample.data('i18n') || {};

    copyTable($sample.find('.js-csv-import-sample-table')).then(function () {
      $status.removeClass('is-error').text(i18n.copied);
    }).catch(function (error) {
      $status.addClass('is-error').text(i18n.copyFailed);
      console.error('Copy failed:', error);
    });
  });

  $(document).on('click', '.js-csv-import-copy', function () {
    const $button = $(this);
    const $list = $button.closest('.js-csv-import-members');
    const $status = $list.siblings('.js-csv-import-copy-status');
    const i18n = $list.data('i18n') || {};
    const name = String($button.data('copy-text'));

    copyText(name).then(function () {
      $list.find('.js-csv-import-copy').removeClass('is-copied');
      $button.addClass('is-copied');
      $status.removeClass('is-error').text(i18n.copied.replace('%{name}', name));
      clearTimeout($button.data('copiedTimer'));
      $button.data('copiedTimer', setTimeout(function () {
        $button.removeClass('is-copied');
      }, COPIED_MS));
    }).catch(function (error) {
      $status.addClass('is-error').text(i18n.copyFailed);
      console.error('Copy failed:', error);
    });
  });
})();
